export const AUDIO_DROPZONE_ACCEPT = {
	'audio/mpeg': ['.mp3'],
	'audio/mp3': ['.mp3'],
	'audio/wav': ['.wav'],
	'audio/x-wav': ['.wav'],
	'audio/mp4': ['.m4a'],
	'audio/x-m4a': ['.m4a'],
	'audio/aac': ['.aac'],
	'audio/ogg': ['.ogg'],
	'audio/webm': ['.webm'],
}

export const isAudioFile = (file: File) => {
	if (/\.(mp3|wav|m4a|aac|ogg|webm)$/i.test(file.name)) return true

	const mime = String(file.type || '').toLowerCase()
	return mime.startsWith('audio/')
}

export const pickAudioFiles = (files: File[]) => files.filter(isAudioFile)
